<template>
  <div>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="px-3">
      <p class="font-size-xSmall" v-html="$t('add_coupon_to_advertiser', {name: advertiser.name})"></p>
      <form class="default-form" @submit.prevent="submit">
        <div class="form-group mb-3">
          <input type="text" class="form-control" :placeholder="$t('code')" v-model.trim="$v.form.code.$model" />
        </div>
        <div>
          <Button
            type="submit"
            class="btn btn-color10 mt-3"
            :disabled="$v.$invalid"
            :loading="loader"
          >
            {{ $t('add_coupon') }}
          </Button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'
import { required } from 'vuelidate/lib/validators'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  props: ['advertiser'],
  name: 'AddCouponModal',
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      loader: false,
      content: null,
      content_type: 'error',
      form: {
        code: ''
      }
    }
  },
  validations () {
    return {
      form: {
        code: { required }
      }
    }
  },
  methods: {
    /**
     * Hidden
     */
    hidden () {
      this.form.code = ''
    },
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      this.content = null
      try {
        await AdvertisersService.addCouponToAdvertiser({
          id: this.advertiser.id,
          code: this.form.code
        })
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('coupon_added_successfully')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$bvModal.hide('add-coupon-modal')
        this.$emit('coupon-added')
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
